/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  orderTranslationChunksConfig
} from '@spartacus/order/assets';
import { ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root';
import { en } from '../../../../../public/translations/en';
import { es } from '../../../../../public/translations/es';

@NgModule({
  imports: [OrderRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('@spartacus/order').then((m) => m.OrderModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: {
            order: en.order,
            myAccountV2Order:en.myAccountV2Order },
          es: {
            order: es.order,
            myAccountV2Order:es.myAccountV2Order }
        },
        chunks: orderTranslationChunksConfig
      },
    }),
  ],
})
export class OrderFeatureModule { }
